import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LogIn } from 'lucide-react';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(formData.email, formData.password);
    setLoading(false);
    if (success) {
      navigate('/account');
    }
  };

  return (
    <div className="bg-off_white min-h-screen flex items-center justify-center py-12" data-testid="login-page">
      <div className="max-w-md w-full mx-auto px-4">
        <div className="bg-white border-4 border-black rounded-2xl p-8 shadow-hard-lg">
          <div className="text-center mb-8">
            <div className="bg-brand_blue w-20 h-20 rounded-full border-4 border-black mx-auto mb-4 flex items-center justify-center">
              <LogIn className="w-10 h-10 text-white" strokeWidth={3} />
            </div>
            <h1 className="font-chewy text-4xl text-brand_blue mb-2">Login</h1>
            <p className="font-nunito text-gray-600 font-semibold">Welcome back to Uncle Dave's!</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="font-nunito font-bold block mb-2">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                data-testid="input-email"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="font-nunito font-bold block mb-2">Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                data-testid="input-password"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand_blue text-white font-chewy text-xl px-8 py-4 rounded-full border-4 border-black shadow-hard-lg hover:shadow-hard-hover hover:-translate-y-1 transition-all disabled:opacity-50"
              data-testid="login-button"
            >
              {loading ? 'LOGGING IN...' : 'LOGIN'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="font-nunito font-semibold">
              Don't have an account?{' '}
              <Link to="/register" className="text-brand_blue font-bold hover:text-brand_red" data-testid="register-link">
                Create one
              </Link>
            </p>
            <Link
              to="/checkout"
              className="block mt-4 font-nunito text-gray-600 hover:text-brand_blue font-semibold"
              data-testid="guest-checkout-link"
            >
              Continue as guest
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;